// This is the parallel Plan Card data structure created from Prismic

import { ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import { GuideProgressType, Service } from '.';
import { AddOnType } from './addon';

export interface PlasmicImage {
  url?: string;
}

export enum UpgradeModalType {
  Split = 'split',
  Whole = 'whole',
}

export enum PlasmicPlanCardUid {
  TmPro = 'tm-pro-2023',
  VmStarter = 'vm-starter-2023',
  VmPro = 'vm-pro-2023',
  VmGrrrowth = 'vm-grrrowth-2023',
  VmCompany = 'vm-company-2023',
}

export enum FontFamilySource {
  Google = 'google',
  SelfHost = 'self-host',
}

/**
 * This is the parallel Plan Card data structure created from Prismic
 * Ref: https://studio.plasmic.app/cms/9Zyjdj71zVjUKppTwbDkgV/schemas/nrKTu3QR1cUTJuViLb3b86
 */
export interface PlanCard {
  uid: PlasmicPlanCardUid;
  service: Service;
  sortOrder: number;
  title: {
    label?: string;
    textColor?: string;
  };
  details: {
    monthlyPrice: number;
    annualPrice: number;
    monthlyPlanSlug: string;
    annualPlanSlug: string;
    description?: string;
  };
  plans: {
    gateway: string;
    monthlySlug: string;
    annualSlug: string;
  }[];
  category?: string;
  ctaVariant?: ButtonVariant;
  badge?: {
    label?: string;
    textColor?: string;
    bgColor?: string;
  };
  image?: PlasmicImage;
  inclusions?: {
    label: string;
  }[];
  bottomBorderColor?: string;
}

/**
 * This is the parallel Plan Card data structure created from Prismic
 * Ref: https://studio.plasmic.app/cms/9Zyjdj71zVjUKppTwbDkgV/schemas/2NBLaZKGJJNtUr7ZvpK1tB
 */
export interface UpgradeModal {
  uid: string;
  header: string;
  type: UpgradeModalType;
  subHeader?: string;
  contentImage?: PlasmicImage;
  backgroundColor?: string;
  relatedAddOn?: AddOnType;
}

/**
 * This is the parallel Onboarding Panel data structure created from Prismic
 * Ref: https://studio.plasmic.app/cms/9Zyjdj71zVjUKppTwbDkgV/schemas/eyNXf5xeFTkWYtiu6EDcnG
 */
export interface OnboardingPanel {
  guideProgressType: GuideProgressType;
  service: Service;
  category: string;
  panelBackgroundColour: boolean;
  header: string;
  description: string;
  callToActions?: {
    label: string;
    variant: ButtonVariant;
    link: string;
    sortOrder: number;
  }[];
  subDescription: string;
  videoLink: string;
  videoPoster: PlasmicImage;
  imageInsteadOfVideo: PlasmicImage;
  dependencies?: GuideProgressType[];
}

/**
 * This is the parallel Onboarding Sort Order data structure created from Prismic
 * Ref: https://studio.plasmic.app/cms/9Zyjdj71zVjUKppTwbDkgV/schemas/pZXXmgbC9gYUFwLNuoTigk
 */
export interface OnboardingSortOrder {
  uid: string;
  service: Service;
  sortOrder?: {
    guideProgressType: GuideProgressType;
    dependencies?: {
      guideProgressType: GuideProgressType;
    }[];
  }[];
}

/**
 * This is the parallel Onboarding Guidelines data structure created from Prismic
 * Ref: https://studio.plasmic.app/cms/9Zyjdj71zVjUKppTwbDkgV/schemas/4nXKWkA4zuPB6GhzFHkTZL
 */
export interface OnboardingGuidelines {
  uid: string;
  service: Service;
  contents?: {
    title: string;
    image: PlasmicImage;
    description: string;
    url: string;
    type: 'cta' | 'video';
  }[];
}

/**
 * This is the parallel Font Family data structure created from Prismic
 * Ref: https://studio.plasmic.app/cms/9Zyjdj71zVjUKppTwbDkgV/schemas/bfJvxc5h7NQpSzPWZgPXuD
 */
export interface FontFamily {
  name: string;
  value: string;
  source: FontFamilySource;
}

/**
 * This are the names of the created Model on Plasmic
 * Ref: https://docs.plasmic.app/learn/plasmic-cms-api-reference/#find-your-model-id
 */
export const enum PlasmicModelType {
  PlanCard = 'planCard',
  UpgradeModal = 'upgradeModal',
  OnboardingPanel = 'onboardingPanels',
  OnboardingSortOrder = 'onboardingSortOrders',
  OnboardingGuidelines = 'onboardingGuidelines',
  fontFamily = 'fontFamily',
}

// This represents all the Plasmic CMS Model as a generic component
export type PlasmicModel = PlanCard | UpgradeModal;
